/* global Alpine */

/**
 * Richiesta rimborso del credito residuo (overpaid).
 */
export default function bookingRefundCredit() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('bookingRefundCredit', () => ({
      config: {},
      modalOpen: false,
      step: 'confirm',
      error: null,
      result: {},

      init() {
        const raw = this.$el.getAttribute('data-refund-config')
        if (raw) {
          try {
            this.config = JSON.parse(raw)
          } catch {
            this.config = {}
          }
        }
      },

      formatPrice(amount) {
        if (amount === undefined || amount === null) return ''
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: this.config.currency || 'EUR',
        }).format(amount)
      },

      creditAmount() {
        return this.config.creditAmount ?? 0
      },

      confirmMessage() {
        const strings = this.config.strings || {}
        const tpl =
          strings.confirmMessage ||
          'Confermi di voler richiedere il rimborso del credito residuo di %s?'
        return tpl.replace('%s', this.formatPrice(this.creditAmount()))
      },

      successMessage() {
        const strings = this.config.strings || {}
        const amount = this.result.refund_amount_gross ?? this.creditAmount()
        const tpl =
          strings.successMessage ||
          'Il rimborso di %s è stato avviato. Potrebbero essere necessari alcuni giorni lavorativi per la visualizzazione sul conto.'
        return tpl.replace('%s', this.formatPrice(amount))
      },

      openModal() {
        this.modalOpen = true
        this.step = 'confirm'
        this.error = null
        this.result = {}
      },

      async submitRefund() {
        if (this.step === 'processing') return

        this.error = null
        this.step = 'processing'
        const strings = this.config.strings || {}

        try {
          const url =
            this.config.refundEndpoint || '/api?endpoint=request-refund-credit'
          const res = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              booking_sid: this.config.bookingSid || '',
            }),
          })
          const data = await res.json()

          if (!res.ok || data.error) {
            this.error = data.error || strings.refundError || 'Errore.'
            this.step = 'confirm'
            return
          }

          this.result = data.result || {}
          this.step = 'success'
        } catch {
          this.error = strings.refundError || 'Errore.'
          this.step = 'confirm'
        }
      },

      finish() {
        window.location.reload()
      },
    }))
  })
}
